import { ApiParameter, get, HasPagingParameters, patch, post, request } from "@insite/client-framework/Services/ApiService";
import { GetOrderApiParameter } from "@insite/client-framework/Services/OrderService";
import { AttributeTypeFacetModel, BaseModel, OrderModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";

const apiUri = "/api/v2/dana/standardReturnsHistory";

export interface GetStandardReturnHistoryParameter extends HasPagingParameters {
  erpOrderNumber?: string;
  webOrderNumber?: string;
  customerPO?: string;
  fromDate?: string; // ISO date string, e.g., "2025-09-08"
  statuses?: string;
  toDate?: string;
  orderDate?: string;
  sortBy?: string;
  orderType?: string;
}


export interface GetStandardReturnHistoryAPIParameter extends GetStandardReturnHistoryParameter, ApiParameter {
}


export interface StandardReturnOrder {
  erpOrderNumber: string;
  webOrderNumber: string;
  customerPO: string;
  createdOn: string;  // Using string here for ISO date strings from backend
  orderDate: string;
  orderType?: string;
  status: string;
}

export interface StandardReturnsOrderDetails extends BaseModel {
  standardReturnsOrder: OrderModel;
}
export interface StandardReturnStatusResult extends BaseModel {
  orders: StandardReturnOrder[];
  pagination: PaginationModel
}
export async function getStandardReturnHistory(parameter: GetStandardReturnHistoryAPIParameter) {
  const standardReturnHistoryResult = await get<StandardReturnStatusResult>(`${apiUri}/`, parameter);
  return standardReturnHistoryResult;
}
export async function getSalseRepContacts(customerId: string) {
  const response = await get<string[]>(`${apiUri}/getContacts`, {
    customerId,
  } as ApiParameter);

  return response;
}


